import React from 'react'
import { node } from 'prop-types'
import { Auth0Provider } from '@auth0/auth0-react'

import AuthRoutine from './AuthRoutine'

// eslint-disable-next-line
const AuthProvider = ({ children }) => (
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    }}
    onRedirectCallback={(appState) =>
      window.history.replaceState({}, '', appState.returnTo || window.location.pathname)
    }
  >
    <AuthRoutine>{children}</AuthRoutine>
  </Auth0Provider>
)

AuthProvider.propTypes = {
  children: node.isRequired,
}

export default AuthProvider
